import { useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useGetCategory } from "common/hooks/user/Products/useGetCategory";
import { enum_api_uri } from "common/hooks/utils/enum";
import { OutletContextProps } from "./-components/formik-utils";
import RefreshRedirect from "./-components/RefreshRedirect";
import Header from "user/components/common/Header";
import Progressbar from "./-components/Progressbar";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";
import { cancelMessage, SystemPopup } from "user/components/common/Overlay";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";
import { ReactComponent as CoryoLogoImg } from "../../assets/icons/coryo_text_logo_white.svg";
import { ReactComponent as Empty } from "../../../common/assets/icons/empty.svg";

export default function SelectCategory({ update = false }: { update?: boolean }) {
    const navigate = useNavigate();
    const params = useParams();
    const [searchtxt, setSearchtxt] = useState("");
    const context = useOutletContext<OutletContextProps>();
    const formik = context.formik;
    const { setFieldValue } = formik.product;
    const customer_idx = formik.from.values.customer_idx;
    const { data: categoryData } = useGetCategory(customer_idx ?? 0, searchtxt);
    const { overlay, closeOverlay, openOverlay } = useOverlay();
    // console.log("categoryData", categoryData);

    return (
        <RefreshRedirect customerIdx={customer_idx} isUpdate={update}>
            <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
                <div className="sticky top-0 bg-white z-[2]">
                    <Header
                        title="2. 상품 선택"
                        goBack
                        onClickClose={() => openOverlay(<SystemPopup isConfirm message={cancelMessage(update)} onClickClose={closeOverlay} />)}
                    />
                    <Progressbar step={2} className="wrapper" />
                    <div className="wrapper">
                        <div className="rounded-[8px] bg-[#F3F3F8] py-[8px] px-[12px] flex">
                            <input
                                type="text"
                                value={searchtxt}
                                onChange={e => setSearchtxt(e.target.value)}
                                placeholder="찾으시는 상품이 있으신가요?"
                                className="flex-1 bg-transparent placeholder:text-[#999] focus:outline-none"
                            />
                            <SearchIcon />
                        </div>
                    </div>
                </div>

                <div className="wrapper bg-white flex-1 flex flex-col min-h-[100dvh]">
                    {categoryData && categoryData?.length > 0 && (
                        <ul className="py-[16px] flex flex-col gap-[16px]">
                            {categoryData?.map(c => {
                                return (
                                    <li
                                        key={c.product_category_idx}
                                        className="flex gap-[16px] items-center cursor-pointer"
                                        onClick={() => {
                                            setFieldValue("category_idx", c.product_category_idx.toString());
                                            update
                                                ? navigate(`/orders/${params.idx}/update/select-product`)
                                                : navigate(`/new-order/select-product`);
                                        }}
                                    >
                                        <figure className="w-[60px] h-[60px] rounded-full shrink-0 border border-[#E5E5F1] overflow-hidden">
                                            {c.category_image ? (
                                                <img
                                                    src={enum_api_uri.api_uri + "/" + c.category_image.replace(/\\/g, "/")}
                                                    alt={c.category_name}
                                                    className="w-full h-full object-cover"
                                                />
                                            ) : (
                                                <div className="bg-[#E5E5F1] border border-[#E5E5F1] w-full h-full flex items-center justify-center">
                                                    <CoryoLogoImg />
                                                </div>
                                            )}
                                        </figure>
                                        <p className="break-all">{c.category_name}</p>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {categoryData?.length === 0 && searchtxt && (
                        <div className="flex-1 flex flex-col gap-[40px] items-center justify-center">
                            <Empty />
                            <p className="text-[20px] text-[#273219] leading-[30px] font-[500]">상품이 없습니다.</p>
                        </div>
                    )}
                </div>
            </OverlayWrapper>
        </RefreshRedirect>
    );
}
